<form [formGroup]="editTypeForm" *ngIf="!isLoading else loadingView">
    <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Name</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <input
                    type="text"
                    formControlName="name"
                    id="name"
                    placeholder="Enter a type name"/>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Description</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <input
                        type="text"
                        formControlName="description"
                        id="description"
                        placeholder="Enter a description"/>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Category</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown
                    formControlName="category"
                    [options]="categories"
                    placeholder="Select Category"
                    optionLabel="name"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Account</acabim-form-input-label>
            <acabim-form-input-content>
                <p-dropdown
                    formControlName="account"
                    [options]="accounts"
                    placeholder="Select Account"
                    optionLabel="name"
                ></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Term</acabim-form-input-label>
            <acabim-form-input-content>
                <p-checkbox formControlName="term" [binary]="true" [label]="'Long'"></p-checkbox>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Expense Type</acabim-form-input-label>
            <acabim-form-input-content>
                <ng-container *ngFor="let priority of expenseType">
                    <p-radioButton name="priority"
                                   formControlName="priority"
                                   [value]="priority.key"
                                   [label]='priority.name' [inputId]="priority.name">
                    </p-radioButton>
                </ng-container>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>

     <div class="cas-action-buttons cas-action-buttons-bottom">
        <button class="cas-button-action cas-button-left" (click)="onSubmit()">{{actionType}}</button>
    </div>
</form>

<p-toast position="center"></p-toast>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
